import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarClock, ArrowUpRight } from 'lucide-react';
import publicApi, { dayMonthFromDate, formatTimeRange } from '../lib/publicApi';
import { useI18n } from '../contexts/I18nContext';

export default function HappeningNext() {
  const { t } = useI18n();
  const [event, setEvent] = useState(null);

  useEffect(() => {
    let mounted = true;
    publicApi
      .get('/events', { params: { status: 'published', upcoming: true, limit: 1 } })
      .then((res) => {
        if (!mounted) return;
        const ev = (res.data || [])[0];
        if (ev) setEvent(ev);
      })
      .catch(() => {
        /* fail silently — hero is fine without this */
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (!event) return null;

  const { day, month } = dayMonthFromDate(event.start_date);
  const time = formatTimeRange(event.start_time, event.end_time);

  return (
    <Link
      to="/summer-series"
      className="group inline-flex items-center gap-3 px-3 py-2 pr-5 rounded-full bg-white/85 backdrop-blur-sm border border-[#2A1B1A]/8 shadow-[0_14px_30px_-18px_rgba(42,27,26,0.4)] hover:border-[#E5614C]/40 hover:-translate-y-0.5 transition-[transform,border-color,box-shadow] duration-300"
      data-testid="happening-next"
    >
      <div className="flex flex-col items-center justify-center h-10 w-10 rounded-xl bg-[#E5614C] text-white shrink-0">
        <span className="text-[13px] font-bold leading-none">{day}</span>
        <span className="text-[8px] tracking-wider mt-0.5 font-semibold">{month}</span>
      </div>
      <div className="text-left">
        <div className="text-[10px] uppercase tracking-[0.18em] font-semibold text-[#5DCAB5] flex items-center gap-1.5">
          <CalendarClock className="h-3 w-3" /> {t('hero.happeningNext')}
        </div>
        <div className="text-[13px] font-semibold text-[#2A1B1A] truncate max-w-[220px] sm:max-w-[300px]">
          {event.title}
          {time ? <span className="text-[#2A1B1A]/55 font-normal"> · {time}</span> : null}
        </div>
      </div>
      <ArrowUpRight className="h-4 w-4 text-[#2A1B1A]/40 group-hover:text-[#E5614C] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
    </Link>
  );
}
